import useSWR from 'swr';
import { getAvaliacaoById } from '../services/avaliacao';

// Busca a avaliação pelo código do laudo (mesmo padrão do useEcg / useHolter)
export default function useAvaliacao(id) {
  return useSWR(id ? ['avaliacao', id] : null, () => getAvaliacaoById(id));
}
